import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-app-selector',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="relative inline-block w-64">
      <div 
        (click)="toggleOpen()"
        class="bg-zaxis-dark border border-zaxis-border px-4 py-2 text-[11px] font-mono tracking-widest uppercase text-white hover:border-zaxis-accent cursor-pointer flex justify-between items-center h-[38px] rounded-none z-10 relative">
        <span class="truncate">{{ selectedApp === 'all' ? 'Todas las Apps' : selectedApp }}</span>
        <i class="ph ph-caret-down text-gray-500"></i>
      </div>

      <!-- Dropdown Panel -->
      <div *ngIf="isOpen" class="absolute top-full left-0 mt-1 w-full bg-zaxis-dark border border-zaxis-accent z-50 rounded-none shadow-xl">
        <div class="p-2 border-b border-zaxis-border relative z-50">
          <input 
            type="text" 
            [(ngModel)]="searchQuery" 
            (click)="$event.stopPropagation()"
            placeholder="Buscar app..." 
            class="w-full bg-black border border-zaxis-border px-2 py-1.5 text-[11px] font-mono text-white focus:outline-none focus:border-zaxis-accent rounded-none">
        </div>
        
        <div class="max-h-64 overflow-y-auto custom-scrollbar relative z-50">
          <div 
            (click)="selectApp('all')"
            class="px-4 py-2.5 text-[11px] font-mono tracking-widest uppercase cursor-pointer hover:bg-zaxis-accent/10 hover:text-zaxis-accent"
            [ngClass]="{'text-zaxis-accent bg-zaxis-accent/5': selectedApp === 'all', 'text-gray-400': selectedApp !== 'all'}">
            Todas las Apps
          </div>
          <div 
            *ngFor="let app of filteredApps" 
            (click)="selectApp(app)"
            class="px-4 py-2.5 text-[11px] font-mono tracking-widest uppercase cursor-pointer hover:bg-zaxis-accent/10 hover:text-zaxis-accent truncate"
            [ngClass]="{'text-zaxis-accent bg-zaxis-accent/5': selectedApp === app, 'text-gray-400': selectedApp !== app}">
            {{ app }}
          </div>
          <div *ngIf="filteredApps.length === 0" class="px-4 py-4 text-center text-gray-500 text-[10px] font-mono uppercase tracking-widest">
            No se encontraron apps
          </div>
        </div>
      </div>
      
      <!-- Invisible overlay to detect clicks outside -->
      <div *ngIf="isOpen" class="fixed inset-0 z-40" (click)="close()"></div>
    </div>
  `
})
export class AppSelectorComponent {
  @Input() apps: string[] = [];
  @Input() selectedApp: string = 'all';
  @Output() appChange = new EventEmitter<string>();

  isOpen = false;
  searchQuery = '';

  get filteredApps(): string[] {
    if (!this.searchQuery) return this.apps;
    const q = this.searchQuery.toLowerCase();
    return this.apps.filter(app => app.toLowerCase().includes(q));
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.searchQuery = '';
    }
  }

  close() {
    this.isOpen = false;
  }

  selectApp(app: string) {
    this.selectedApp = app;
    this.appChange.emit(app);
    this.close();
  }
}
